import CheckIcon from '@mui/icons-material/Check';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const LabelWithIndicator = ({ children }) => {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <CheckIcon color="secondary" fontSize="small" />
      <Typography variant="body2" color={theme.palette.grey[600]}>
        {children}
      </Typography>
    </Stack>
  );
};

LabelWithIndicator.propTypes = {
  children: PropTypes.string
};

export default LabelWithIndicator;
